import axios from 'axios';

const API_URL = import.meta.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor for auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

// Re-export from apiRoutes for backward compatibility
export { ticketsAPI, geocodeAPI, vehiculosAPI, rutasAPI, arcgisAPI, exportAPI } from './apiRoutes';
